<template>
    <v-form
            v-model="valid"
            ref="userForm"
            lazy-validation
            @submit.prevent="onSubmit"
            @keyup.native.enter="onSubmit"
    >
        <v-card
                :loading="loading"
                :disabled="loading"
        >
            <v-card-title>User Info</v-card-title>
            <v-card-text>
                <v-text-field
                        v-model="user.email"
                        label="Email"
                        disabled
                        outlined
                        hint="Cannot be changed"
                        persistent-hint
                        class="mb-3"
                ></v-text-field>
                <v-text-field
                        v-model="user.name"
                        :rules="[rules.required]"
                        label="Name"
                        required
                        :disabled="loading"
                        outlined
                ></v-text-field>
                <v-radio-group v-model="user.status" label="Status" class="mt-0">
                    <v-radio
                            v-for="(i, index) in user_status_list"
                            :key="index"
                            :label="i"
                            :value="index.toString()"
                            :color="statusColor(index)"
                    ></v-radio>
                </v-radio-group>
            </v-card-text>
            <v-card-actions class="px-4 pb-5">

                <v-spacer></v-spacer>

                <v-btn
                        color="success"
                        :loading="loading"
                        :disabled="loading"
                        type="submit"
                >
                    Save
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
    export default {
        name: "UserInfo",
        props: {
            id:{
                type: String,
                default: 0
            }
        },
        data(){
            return {
                loading: false,
                valid: false,
                rules      : {
                    required : value => !!value || 'Required field.',
                },
                user: {
                    email: null,
                    name: null,
                    status: null,
                },
                user_status_list: []
            }
        },
        created(){
            this.getUser();
        },
        methods:{

            statusColor( status = null ){
                const colors = {
                    '0': 'red',
                    '1': 'green',
                    '2': 'yellow',
                };

                return colors.hasOwnProperty(status) ? colors[status] : 'grey'
            },

            getUser(){

                this.loading = true;
                this.axios.post( 'user/edit', JSON.stringify( {
                    method: 'show',
                    id: this.id,
                } ) )
                .then((response)=>{

                    const params = response.data;

                    if( params.status === 'success' && params.hasOwnProperty('data' ) ){
                        this.user.email = params.data.user.email;
                        this.user.name = params.data.user.name;
                        this.user.status = params.data.user.status;
                        this.user_status_list = params.data.user_status_list
                    } else {
                        this.$emit('alert', {type:'error', message: params.message});
                    }

                    this.loading = false;

                }).catch(()=>{
                    this.$emit('alert', {type:'error', message: 'Data has not been received'});
                    this.loading = false;
                });
            },

            onSubmit(){
                if( this.$refs.userForm.validate() ) {
                    this.saveUserInfo();
                }
            },

            saveUserInfo(){
                this.loading = true;
                this.axios.post( 'user/edit', JSON.stringify( {
                    method: 'save',
                    id: this.id,
                    name: this.user.name,
                    status: this.user.status,
                } ) )
                .then((response)=>{

                    const params = response.data;

                    if( params.status === 'success'){
                        this.$emit('alert', {type:'success', message: params.message});
                    } else {
                        this.$emit('alert', {type:'error', message: params.message});
                    }

                    this.loading = false;

                }).catch(()=>{
                    this.$emit('alert', {type:'error', message: 'Data has not been received'});
                    this.loading = false;
                });
            }
        }
    }
</script>